import type { MessageHandlerDeps } from '../message-handler-deps.js';
import type { ApiToBridgeMessage } from '../../types/api-to-bridge-messages.js';
import { handlePreviewEnvironmentControl } from '../handlers/preview-environment-control.js';
import { handlePreviewEnvironmentsConfig } from '../handlers/preview-environments-config.js';
import { handleDeploySessionToPreviewMessage } from '../handlers/deploy-session-to-preview.js';

export function dispatchBridgePreviewMessage(
  msg: Extract<
    ApiToBridgeMessage,
    { type: 'preview_environments_config' | 'preview_environment_control' | 'deploy_session_to_preview' }
  >,
  deps: MessageHandlerDeps
): void {
  switch (msg.type) {
    case 'preview_environments_config':
      handlePreviewEnvironmentsConfig(msg, deps);
      break;
    case 'preview_environment_control':
      handlePreviewEnvironmentControl(msg, deps);
      break;
    case 'deploy_session_to_preview':
      handleDeploySessionToPreviewMessage(msg, deps);
      break;
  }
}
